import { CircleCheck } from "lucide-react";
import TaskCard from "./TaskCard";
import "./upcomingHearings.css";
import { useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";
import { getTodayTasks } from "../../../services/dashboardService";

export default function TasksDueToday() {
  const [tasks, setTasks] = useState([]);
  const [showAllTasks, setShowAllTasks] = useState(false);

  const navigate = useNavigate();

useEffect(() => {
  const loadTasks = async () => {
    const data = await getTodayTasks();
    setTasks(data);
  };

  loadTasks();
}, []);
const visibleTasks = showAllTasks
  ? tasks
  : tasks.slice(0, 5);
  return (
    <div className="dashboard-panel">

      <div className="panel-header">

        <div className="panel-title">
          <CircleCheck size={18} />
          <span>Tasks Due Today</span>
        </div>

        <button className="panel-link"
        onClick={() => navigate("/portal/tasksevents")}>
          View all tasks
        </button>

      </div>

      {tasks.length === 0 ? (
  <div className="no-hearings">
    No tasks due today
  </div>
) : (
  <>
    {visibleTasks.map((task) => (
      <TaskCard
        key={task.docId}
        title={task.title}
        time={task.time}
        description={task.description}
        priority={task.priority || "Normal"}
      />
    ))}

    {tasks.length > 5 && (
      <button
        className="more-task-btn"
        onClick={() => setShowAllTasks(!showAllTasks)}
      >
        {showAllTasks
          ? "Show less ⌃"
          : `${tasks.length - 5} more tasks ⌄`}
      </button>
    )}
  </>
)}

    </div>
  );
}